import React from 'react';
import '../styles/LeadViewModal.css';

function formatDate(d) {
  if (!d) return '—';
  return new Date(d).toLocaleDateString('en-AU', {
    day: 'numeric',
    month: 'short',
    year: 'numeric',
  });
}

function statusLabel(status) {
  const s = String(status || '').toLowerCase();
  if (s === 'approve') return 'Qualified';
  if (s === 'assigned') return 'In Progress';
  if (s === 'cancel') return 'Lost';
  return 'New';
}

export default function LeadViewModal({ lead, onClose, onEdit }) {
  if (!lead) return null;

  const initials = String(lead.clientName || '?')
    .split(' ')
    .map((w) => w[0])
    .join('')
    .slice(0, 2)
    .toUpperCase();

  return (
    <div className="lead-view-overlay" onClick={onClose}>
      <div
        className="lead-view-modal"
        onClick={(e) => e.stopPropagation()}
        role="dialog"
        aria-modal="true"
        aria-labelledby="lead-view-title"
      >
        <div className="lead-view-header">
          <div className="lead-view-identity">
            <div className="lead-view-avatar">{initials}</div>
            <div>
              <h2 id="lead-view-title">{lead.clientName}</h2>
              <p>{lead.source || 'Website'}</p>
            </div>
          </div>
          <button type="button" className="lead-view-close" onClick={onClose} aria-label="Close">
            ×
          </button>
        </div>

        <div className="lead-view-grid">
          <div className="lead-view-field">
            <span>Email</span>
            <strong>{lead.contactEmail || '—'}</strong>
          </div>
          <div className="lead-view-field">
            <span>Phone</span>
            <strong>{lead.contactNumber || '—'}</strong>
          </div>
          <div className="lead-view-field">
            <span>Address</span>
            <strong>{lead.address || '—'}</strong>
          </div>
          <div className="lead-view-field">
            <span>Service type</span>
            <strong>{lead.serviceName || '—'}</strong>
          </div>
          <div className="lead-view-field">
            <span>Postcode</span>
            <strong>{lead.postcode || '—'}</strong>
          </div>
          <div className="lead-view-field">
            <span>Assigned branch</span>
            <strong>{lead.branchName || lead.branchId || '—'}</strong>
          </div>
          <div className="lead-view-field">
            <span>Pipeline stage</span>
            <strong>{lead.stage?.name || '—'}</strong>
          </div>
          <div className="lead-view-field">
            <span>Status</span>
            <strong>
              <span className={`lm-status-badge lm-status-badge--${lead.label || 'pending'}`}>
                {statusLabel(lead.label)}
              </span>
            </strong>
          </div>
          <div className="lead-view-field">
            <span>Estimated value</span>
            <strong>
              {lead.estimatedValue
                ? `$${lead.estimatedValue.toLocaleString()}/mo`
                : '—'}
            </strong>
          </div>
          <div className="lead-view-field">
            <span>Source</span>
            <strong>{lead.source || 'Website'}</strong>
          </div>
          <div className="lead-view-field">
            <span>Created</span>
            <strong>{formatDate(lead.createdAt)}</strong>
          </div>
        </div>

        {lead.message && (
          <div className="lead-view-notes">
            <span>Notes</span>
            <p>{lead.message}</p>
          </div>
        )}

        <div className="lead-view-actions">
          <button type="button" className="action-button" onClick={onClose}>
            Close
          </button>
          <button
            type="button"
            className="action-button primary"
            onClick={() => {
              onEdit?.(lead);
              onClose();
            }}
          >
            Edit lead
          </button>
        </div>
      </div>
    </div>
  );
}
